// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__F5NwR","buttons":"RemoveExpirationActionButtons_buttons__7flvc"};